/* ============================================================
   UTILISMO — JS das seções ut- (slider, contadores, scroll-vídeo)
   Vanilla, sem dependências. Reinicializa no editor de temas.
   ============================================================ */

(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. HERO SLIDER (fade automático) ---------- */

  function initSlider(scope) {
    scope.querySelectorAll('[data-ut-slider]').forEach(function (root) {
      if (root.dataset.utBound === 'true') return;
      root.dataset.utBound = 'true';

      var slides = root.querySelectorAll('[data-ut-slide]');
      var dots = root.querySelectorAll('[data-ut-dot]');
      if (slides.length < 2) return;

      var i = 0;
      var delay = parseInt(root.dataset.utSlider, 10) || 6000;
      var timer = null;

      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('ut-is-active', k === i);
          s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        });
        dots.forEach(function (d, k) {
          d.classList.toggle('ut-is-active', k === i);
        });
      }

      function play() {
        if (REDUCED) return;
        stop();
        timer = window.setInterval(function () { go(i + 1); }, delay);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { go(k); play(); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);

      go(0);
      play();
    });
  }

  /* ---------- 2. CONTADORES (sobem quando entram na tela) ---------- */

  function initCounters(scope) {
    var els = scope.querySelectorAll('[data-ut-count]');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);

        var el = entry.target;
        var target = parseInt(el.dataset.utCount, 10) || 0;

        if (REDUCED) { el.textContent = target.toLocaleString('pt-BR'); return; }

        var start = null;
        var dur = 1400;

        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString('pt-BR');
          if (p < 1) window.requestAnimationFrame(tick);
        }

        window.requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });

    els.forEach(function (el) {
      if (el.dataset.utBound === 'true') return;
      el.dataset.utBound = 'true';
      io.observe(el);
    });
  }

  /* ---------- 3. VÍDEO CONTROLADO PELO SCROLL ---------- */

  function initScrolly(scope) {
    scope.querySelectorAll('[data-ut-scrolly]').forEach(function (root) {
      if (root.dataset.utBound === 'true') return;
      root.dataset.utBound = 'true';

      var video = root.querySelector('video');
      var steps = root.querySelectorAll('[data-ut-step]');
      if (!video) return;

      // Sem scroll-scrub no celular ou com movimento reduzido: vídeo em loop normal
      var scrub = !REDUCED && window.matchMedia('(min-width: 750px)').matches;

      if (!scrub) {
        video.loop = true;
        video.muted = true;
        video.play().catch(function () {});
        steps.forEach(function (s) { s.classList.add('ut-is-on'); });
        return;
      }

      video.pause();

      var ticking = false;

      function onScroll() {
        if (ticking) return;
        ticking = true;

        window.requestAnimationFrame(function () {
          var rect = root.getBoundingClientRect();
          var total = rect.height - window.innerHeight;
          var p = Math.min(Math.max(-rect.top / Math.max(total, 1), 0), 1);

          if (video.duration) {
            video.currentTime = video.duration * p;
          }

          var active = Math.min(Math.floor(p * steps.length), steps.length - 1);
          steps.forEach(function (s, k) {
            s.classList.toggle('ut-is-on', k <= active);
          });

          ticking = false;
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      video.addEventListener('loadedmetadata', onScroll);
      onScroll();
    });
  }

  /* ---------- 4. VÍDEOS DA VITRINE (tocam quando visíveis) ---------- */

  function initInviewVideos(scope) {
    var vids = scope.querySelectorAll('[data-ut-autoplay], .ut-vid__media video');
    if (!vids.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.35 });

    vids.forEach(function (v) {
      if (v.dataset.utBound === 'true') return;
      v.dataset.utBound = 'true';
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      io.observe(v);
    });
  }

  /* ---------- BOOT ---------- */

  window.UTExtra = window.UTExtra || {};

  window.UTExtra.init = function (scope) {
    var root = scope || document;
    initSlider(root);
    initCounters(root);
    initScrolly(root);
    initInviewVideos(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.UTExtra.init(); });
  } else {
    window.UTExtra.init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    window.UTExtra.init(e.target);
  });
})();
